// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
import { _DYN_COUNT, _DYN_MEASUREMENTS, _DYN_NAME, _DYN_PROPERTIES, _DYN_VALUE } from "../../__DynamicConstants";
import { strNotSpecified } from "../../constants/Constants";
import { DataPoint } from "./Common/DataPoint";
import { dataSanitizeMeasurements, dataSanitizeProperties, dataSanitizeString } from "./Common/DataSanitizer";
import { MetricDataType } from "./DataTypes";
import { MetricEnvelopeType } from "./EnvelopeTypes";
var Metric = /** @class */ (function () {
    /**
     * Constructs a new instance of the MetricTelemetry object
     */
    function Metric(logger, name, value, count, min, max, stdDev, properties, measurements) {
        this.aiDataContract = {
            ver: 1 /* FieldType.Required */,
            metrics: 1 /* FieldType.Required */,
            properties: 0 /* FieldType.Default */
        };
        var _self = this;
        _self.ver = 2;
        var dataPoint = new DataPoint();
        dataPoint[_DYN_COUNT /* @min:%2ecount */] = count > 0 ? count : undefined;
        dataPoint.max = isNaN(max) || max === null ? undefined : max;
        dataPoint.min = isNaN(min) || min === null ? undefined : min;
        dataPoint[_DYN_NAME /* @min:%2ename */] = dataSanitizeString(logger, name) || strNotSpecified;
        dataPoint[_DYN_VALUE /* @min:%2evalue */] = value;
        dataPoint.stdDev = isNaN(stdDev) || stdDev === null ? undefined : stdDev;
        _self.metrics = [dataPoint];
        _self[_DYN_PROPERTIES /* @min:%2eproperties */] = dataSanitizeProperties(logger, properties);
        _self[_DYN_MEASUREMENTS /* @min:%2emeasurements */] = dataSanitizeMeasurements(logger, measurements);
    }
    /**
     * @deprecated Use the constant MetricEnvelopeType instead.
     */
    Metric.envelopeType = MetricEnvelopeType;
    /**
     * @deprecated Use the constant MetricDataType instead.
     */
    Metric.dataType = MetricDataType;
    return Metric;
}());
export { Metric };
//# sourceMappingURL=Metric.js.map